import {apiAxios} from "@/service/APIClient";
import BannerDTO from "@/models/BannerDTO";

export const banners = {
    placement: async (placement: string): Promise<BannerDTO[]> => {
        let resp = await apiAxios({
            url: `/banners/placement/${placement}`,
            method: 'GET',
        })

        return resp.data as BannerDTO[]
    },
}